export default "/_next/static/chunks/fonts/WhitneySSm-LightItalic-Pro_Web-dae7f6de6e44ab677001ba60ffad14e4.woff2";